module.exports = __webpack_public_path__ + "img/stop.05c14342.svg";